<template>
    <report
        :report="report"
        :versions="versions"
        :loading="loading"
        :refreshing="refreshing"
        @reload="reload"
        @load-version="load_version"
    >
        <div class="lam-graph-container">
            <div class="uk-grid uk-grid-small uk-grid-width-1-2">
                <div></div>
                <div class="uk-text-right">
                    <div class="uk-button-group lam-graph-filter">
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.mode === 'absolute'}"
                            @click.prevent="set_state_value('mode', 'absolute')"
                        >
                            Absolute
                        </base-button>
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.mode === 'relative'}"
                            @click.prevent="set_state_value('mode', 'relative')"
                        >
                            Relative
                        </base-button>
                    </div>

                    <div class="uk-button-group lam-graph-filter">
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.scope === 6}"
                            @click.prevent="set_scope(6)"
                        >
                            6 weeks
                        </base-button>
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.scope === 12}"
                            @click.prevent="set_scope(12)"
                        >
                            3 months
                        </base-button>
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.scope === 26}"
                            @click.prevent="set_scope(26)"
                        >
                            6 months
                        </base-button>
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.scope === 52}"
                            @click.prevent="set_scope(52)"
                        >
                            1 year
                        </base-button>
                    </div>
                </div>
            </div>
            <div class="uk-grid uk-grid-small uk-margin-bottom lam-graph">
                <div class="uk-width-1-1" style="position: relative;">
                    <gas-gauge-graph
                        ref="chart"
                        :chart-data="chart_data"
                        :display-mode="state.mode"
                        style="height: 600px;"
                    />
                </div>
            </div>
        </div>
    </report>
</template>

<script type="text/javascript">
import { draw } from "patternomaly"

import is_big_report from "./IsBigReport"
import handles_projects from "./HandlesProjects"
import uses_color_palette from "../../mixins/UsesColorPalette"

import Report from "./Report.vue"
import BaseButton from "../../ui/BaseButton"
import GasGaugeGraph from "./GasGaugeGraph.js"

export default {
    mixins: [is_big_report, handles_projects, uses_color_palette],
    components: {
        Report,
        BaseButton,
        GasGaugeGraph
    },
    computed: {
        chart_data () {
            const patterned = draw("diagonal", "#ddd")
            const data = {
                labels: [],
                datasets: [
                    {
                        label: "Reserved",
                        backgroundColor: "#0452A6",
                        borderColor: "#0452A6",
                        categoryPercentage: 0.9,
                        barPercentage: 0.8,
                        data: []
                    },
                    {
                        label: "Available",
                        backgroundColor: patterned,
                        borderColor: "#ddd",
                        categoryPercentage: 0.9,
                        barPercentage: 0.8,
                        data: []
                    },
                    {
                        label: "Overtime",
                        backgroundColor: "red",
                        borderColor: "red",
                        categoryPercentage: 0.9,
                        barPercentage: 0.8,
                        data: []
                    }
                ]
            }

            const range_start = this.$moment().startOf("isoWeek")
            const range_end = this.$moment(range_start).add(this.state.scope, "weeks")
            if(this.report) {
                const raw_data = []
                let report_dataset = this.report.dataset[range_start.format("YYYY-MM-DD")] || []
                Object.keys(report_dataset).forEach(initials => {
                    const user = this.raw_user_records.find(user => user.initials === initials)
                    if(user) {
                        data.labels.push(user.initials)
                        raw_data.push({
                            reserved: 0,
                            // max_available: (this.state.mode === "relative") ? 100 : 0
                            max_available: 0
                        })
                    }
                })

                report_dataset = this.report.dataset
                Object.keys(report_dataset).forEach(date_string => {
                    const date = this.$moment(date_string)
                    if(date.isSameOrAfter(range_start) && date.isBefore(range_end)) {
                        let index = 0
                        Object.keys(report_dataset[date_string]).forEach(initials => {
                            const user = this.raw_user_records.find(user => user.initials === initials)
                            if(user) {
                                const hours = report_dataset[date_string][initials].hours
                                const available_hours = report_dataset[date_string][initials].available

                                // if(this.state.mode === "relative") {
                                //    raw_data[index].reserved += available_hours ? (hours / available_hours) : 0
                                // } else {
                                raw_data[index].reserved += hours
                                raw_data[index].max_available += available_hours
                                // }
                                index++
                            }
                        })
                    }
                })

                raw_data.forEach(user_data => {
                    if(this.state.mode === "relative") {
                        user_data.reserved = user_data.max_available ? Math.round((user_data.reserved / user_data.max_available) * 100) : 0
                        user_data.max_available = 100
                    }
                    data.datasets[0].data.push((user_data.reserved > user_data.max_available) ? user_data.max_available : user_data.reserved)
                    data.datasets[1].data.push((user_data.reserved > user_data.max_available) ? 0 : Math.abs(user_data.max_available - user_data.reserved))
                    data.datasets[2].data.push((user_data.reserved > user_data.max_available) ? (user_data.reserved - user_data.max_available) : 0)
                })
                /*
                const report_dataset = this.report.dataset[range_start.format('YYYY-MM-DD')] || []

                Object.keys(report_dataset).forEach(initials => {
                    const user = this.raw_user_records.find(user => user.initials === initials)
                    if(user) {
                        data.labels.push(user.initials)

                        const hours = report_dataset[initials].hours
                        const available_hours = report_dataset[initials].available
                        const raw_data = {
                            reserved: 0,
                            available: 0,
                            max_available: 100
                        }
                        if(this.state.mode === "relative") {
                            raw_data.reserved = available_hours ? Math.round((hours / available_hours) * 100) : 0
                        } else {
                            raw_data.reserved = hours
                            raw_data.max_available = available_hours // Math.max(raw_data.reserved, available_hours)
                        }
                        raw_data.available = (raw_data.max_available - raw_data.reserved)

                        data.datasets[0].data.push((raw_data.reserved > raw_data.max_available) ? raw_data.max_available : raw_data.reserved)
                        data.datasets[1].data.push((raw_data.reserved > raw_data.max_available) ? 0 : Math.abs(raw_data.available))
                        data.datasets[2].data.push((raw_data.reserved > raw_data.max_available) ? (raw_data.reserved - raw_data.max_available) : 0)
                    }
                })
                */

                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.ymax = 0
                for(let loop = 0; loop < data.labels.length; loop++) {
                    let period_total = 0
                    data.datasets.forEach(dataset => {
                        period_total += parseFloat(dataset.data[loop]) || 0
                    })
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.ymax = Math.max(period_total, this.ymax)
                }
            }

            return data
        }
    },
    data () {
        return {
            report_id: "gas_gauge",

            default_state: {
                scope: 6,
                mode: "relative",
                filter: "",
                user_id: 0,
                studio_id: 0,
                version_id: 0
            }
        }
    }
}
</script>
